export default __webpack_public_path__ + "static/media/convocatoriabarrioabierto.88ac8b6e.pdf";